import { render, staticRenderFns } from "./nylasPopButton.vue?vue&type=template&id=76a159b7&scoped=true&"
import script from "./nylasPopButton.vue?vue&type=script&lang=js&"
export * from "./nylasPopButton.vue?vue&type=script&lang=js&"
import style0 from "./nylasPopButton.vue?vue&type=style&index=0&id=76a159b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a159b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76a159b7')) {
      api.createRecord('76a159b7', component.options)
    } else {
      api.reload('76a159b7', component.options)
    }
    module.hot.accept("./nylasPopButton.vue?vue&type=template&id=76a159b7&scoped=true&", function () {
      api.rerender('76a159b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/newProject/dashboard/nylasPopButton.vue"
export default component.exports